import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * Booking Designer
 */
const factory = function factory({ document, thn }) {
    let refreshPrice = null;
    const roomDetailsParseData = (numAdults, numChildren, nights) => {
        const roomsArray = Array.from(document.querySelectorAll('.reservation-room_item'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.querySelector('.reservation-room_name')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.reservation-package_item'))
                ?.map((rate) => {
                const rateName = rate.querySelector('h5 > .mb-2 > a')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('.reservation-package_price .amout')?.textContent);
                const hasBreakfast = !!rateName?.match(/breakfast|colazione/);
                const isRefundable = !rate.querySelector('[data-toggle="quotation-policy-modal"]')?.textContent?.match(/Resellable/);
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice / nights,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            const roomData = {
                name: roomName,
                adults: numAdults || 1,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        priceObserveDom() {
            const container = document.querySelector('#rooms-solutions');
            if (container && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    const loader = document.querySelector('[data-loader="ajax"]');
                    if (!loader) {
                        thn.widgets.price.refresh().catch(() => { });
                    }
                }, 600);
                thn.observeDom(container, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.pathname.includes('booking-engine');
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            // Dates
            const datesEl = document.querySelector('.date-range-picker')?.value?.split('-');
            if (!datesEl) {
                return null;
            }
            const dateBeginEl = datesEl[0]?.trim();
            const dateEndEl = datesEl[1]?.trim();
            if (!dateBeginEl || !dateEndEl) {
                return null;
            }
            const dateBegin = translateDate(dateBeginEl, thn.data.language) ?? '';
            const dateEnd = translateDate(dateEndEl, thn.data.language) ?? '';
            const nights = thn.daysBetween(dateBegin, dateEnd) || 0;
            // Guests, Adults & Children
            const adults = thn.parseNumber(document.querySelector('.check_availability-field .awe-select button')?.textContent) || 1;
            const children = thn.parseNumber(document.querySelector('.check_availability-field .chds_numb button')?.textContent) || 0;
            const roomsDispo = [];
            const roomInfo = {
                adults,
                children,
                childrenAges: [],
            };
            for (let i = 1; i <= children; i += 1) {
                const childAgeEl = document.querySelector(`.chd_${i} button`)?.textContent;
                const childAge = thn.parseNumber(childAgeEl) ?? 10;
                roomInfo.childrenAges.push(childAge);
            }
            roomsDispo.push(roomInfo);
            // Prices & Currency || No Rooms
            const pricesEl = document.querySelectorAll('.reservation-package_price .amout');
            const prices = Array.from(pricesEl).map((price) => thn.parseNumber(price?.textContent)).filter((value) => typeof value !== 'undefined');
            const minPrice = prices.length ? Math.min(...prices) : null;
            const currency = thn.parseCurrency(document.querySelector('.currency span')?.textContent?.trim());
            const noAvailability = document.querySelector('#rooms-solutions p')?.textContent?.match(/not found solutions|pas trouvé de solutions|non abbiamo trovato soluzioni|haben wir keine Lösungen gefunden/);
            const loader = document.querySelector('[data-loader="ajax"]');
            if (minPrice && currency && !noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo,
                    price: minPrice / nights,
                    currency,
                    roomDetails: roomDetailsParseData(adults, children, nights),
                };
            }
            if (noAvailability || (!minPrice && !loader)) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo,
                    currency,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const dataLayer = (window.dataLayer || []);
            const bookingDataPurchase = (dataLayer
                .filter((data) => data?.[1] === 'purchase')?.[0]?.[2] ?? {});
            const bookingId = document.querySelector('.reservation-heading')?.textContent?.split(':')[1]?.trim() || thn.parseUrlParameter('code') || thn.objectGet(bookingDataPurchase, 'transaction_id', { first: false });
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            const dateBegin = bookingDataPurchase?.items?.[0]?.start_date?.replace(/-/g, '/');
            const dateEnd = bookingDataPurchase?.items?.[0]?.end_date?.replace(/-/g, '/');
            const price = thn.objectGet(bookingDataPurchase, 'value', { first: false }) || thn.parseNumber(document.querySelector('.reservation-room-seleted_total .reservation-total')?.textContent);
            const currency = thn.objectGet(bookingDataPurchase, 'currency', { first: false }) || thn.parseCurrency(document.querySelector('.reservation-room-seleted_total .reservation-total')?.textContent);
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
        },
    };
};

export { factory };
